export const cacheData = {
    GET_STATE_DATA:"GET_STATE_DATA",
    FETCHING_GET_STATE_DATA:'FETCHING_GET_STATE_DATA'
};